import { call, select } from 'redux-saga/effects'
import { databaseSelector } from 'selectors'
import createDocument from 'helpers/databases/createDocument'

export default function * createDocumentSaga(document) {
  const { database } = yield select(databaseSelector)
  const { id, rev } = yield call(createDocument, database, document)
  return { _id: id, _rev: rev }
}



// WEBPACK FOOTER //
// ./src/sagas/createDocumentSaga.js